import { Tag } from '../../../cross-team-shared/annotation/shared/state/shape-state';
import { Attribute } from '../../../team-apis/otterdam/taxonomy';

export abstract class AttributeHelper<
  AttributeType extends Attribute = Attribute,
> {
  abstract getLabel(answer: Tag | undefined, attribute: AttributeType): string;

  abstract getDefaultOptionValue(attribute: AttributeType): Tag;

  abstract isInvalidValue(value: Tag, attribute: AttributeType): boolean;
}
